

//Note: Important!!!
//import the class here, not the object

import {ProductAction} from 'AppAction';
import {HttpService} from 'service/HttpService';

import AppConstants from 'AppConstants';
import Dispatcher from 'service/Dispatcher';

const BASE_URL = AppConstants.BASE_API_URL+"/product";

class ProductAPI extends HttpService { 

    getProductsByType(productType, pageNumber, pageSize, onSuccess) {
		const pgNumber = pageNumber || 0;
		const pgSize = pageSize || AppConstants.DEFAULT_PRODUCT_PAGE_SIZE;

		this.get("/list/type?productType="+productType.val+"&pageNumber="+pgNumber+"&pageSize="+pgSize, response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_TYPE_PRODUCTS,
                products: response.data,
				productType: productType.url.toLowerCase(),
				nextPageNumber: pgNumber + 1,
				pageSize: pgSize
			});

			if(typeof onSuccess === "function") {
				onSuccess();
			}
		});
	}

	//this always returns 1st page data for all product types,
	//for second page, call respective product type API
	getUserProductsPerType(userId, pageSize, onSuccess) {
		const pgSize = pageSize || AppConstants.DEFAULT_PRODUCT_PAGE_SIZE;

		this.get("/"+userId+"/listPerType?pageSize="+pgSize, response => {
			const res = response.data;

			Object.keys(res).forEach(type => {
				const products = res[type];
				Dispatcher.dispatch({
					type: ProductAction.LOAD_USER_PRODUCTS_PER_TYPE,
					products: products,
					userId: userId,
					productType: AppConstants.PRODUCT_TYPES[type].url,
					nextPageNumber: 1,
					pageSize: pageSize
				});
			});
			

			if(typeof onSuccess === "function") {
				onSuccess();
			}
		});
	}

	getRecentProductsByType(productTypes, size) {
		const number = size || 4;
		const types = productTypes.map(t => t.val).join(",");

		this.get("/recentPerType?productTypes="+types+"&number="+number, response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_RECENT_PRODUCTS_PER_TYPE,
				products: response.data
			});
		});
	}

	searchProductsByTag(tagName) {
		this.get("/search/tag?tagName="+tagName, response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_TAG_PRODUCTS,
				products: response.data,
				tag: tagName
			});
		});
	}
	
	searchProducts(keyword) {
		if(!keyword || keyword.length < 2) {
			return;
		}
		
		this.post("/search", {keyword: keyword}, response => {
			Dispatcher.dispatch({
				type: ProductAction.SEARCH_PRODUCTS,
                products: response.data,
				keyword: keyword
			});
		});
	}

	getDiscountedProducts(userId) {
		this.get("/couponlist?userId="+userId, response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_DISCOUNTED_PRODUCTS,
                products: response.data,
				userId: userId
			});
		});
	}

	getFeaturedProducts() {
		this.get("/featured", response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_FEATURED_PRODUCTS,
				products: response.data,
			});
		});
	}

	getPopularProducts() {
		this.get("/popular", response => {
			Dispatcher.dispatch({
				type: ProductAction.LOAD_POPULAR_PRODUCTS,
				products: response.data,
			});
		});
	}
}

export default new ProductAPI(BASE_URL);


// WEBPACK FOOTER //
// ./src/service/api/ProductAPI.js